'use client';

import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

import { Image } from '@/app/components/ui';
import getLocaleFormatting from '@/utils/getLocaleFormatting';

const Content404 = (): JSX.Element => {
  const t = useTranslations();

  return (
    <div className="relative bg-gray-500 pb-96 pt-64 md:pb-96 md:pt-36">
      <Image
        alt="" // not necessary with role="presentation"
        src="404/desktop_bg"
        fill
        format="png"
        priority
        role="presentation"
        sizes="100vw"
        style={{ objectFit: 'cover' }}
      />

      <div className="relative mx-6 flex justify-center xl:mx-auto">
        <div className="max-w-2xl text-center md:flex md:items-center md:text-left">
          <Typography
            variant="h1"
            Element="h1"
            color="light"
            align="centerMdLeft"
            className="mb-4 md:mb-0 md:mr-12"
          >
            404
          </Typography>

          <div>
            <Typography variant="h4" color="light" align="centerMdLeft">
              {t('404_caption')}
            </Typography>

            <Typography
              color="light"
              className="mt-4"
              align="centerMdLeft"
              data-testid="404-back-to-home"
            >
              {t.rich('404_back_to_home_new', getLocaleFormatting)}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content404;
